module.exports = __webpack_public_path__ + "static/media/ambiente.0f3b4691.svg";